module.exports = __webpack_public_path__ + "img/imperial_logo_big.d24ac839.png";